import { Action, Permission, Roles, Subject } from './types';

export const permissions: Permission[] = [
  { role: Roles.SystemUser, action: Action.Create, subject: Subject.App },
  { role: Roles.SystemUser, action: Action.Delete, subject: Subject.App },
  { role: Roles.SystemUser, action: Action.Edit, subject: Subject.App },
  { role: Roles.SystemUser, action: Action.View, subject: Subject.App },
  { role: Roles.SystemUser, action: Action.Create, subject: Subject.Scope },
  { role: Roles.SystemUser, action: Action.Delete, subject: Subject.Scope },
  { role: Roles.SystemUser, action: Action.Edit, subject: Subject.Scope },
  { role: Roles.SystemUser, action: Action.View, subject: Subject.Scope },
  { role: Roles.SystemUser, action: Action.Create, subject: Subject.Target },
  { role: Roles.SystemUser, action: Action.Delete, subject: Subject.Target },
  { role: Roles.SystemUser, action: Action.Edit, subject: Subject.Target },
  { role: Roles.SystemUser, action: Action.View, subject: Subject.Target },

  { role: Roles.EditUser, action: Action.Edit, subject: Subject.App },
  { role: Roles.EditUser, action: Action.View, subject: Subject.App },
  { role: Roles.EditUser, action: Action.Edit, subject: Subject.Scope },
  { role: Roles.EditUser, action: Action.View, subject: Subject.Scope },
  { role: Roles.EditUser, action: Action.Edit, subject: Subject.Target },
  { role: Roles.EditUser, action: Action.View, subject: Subject.Target },

  { role: Roles.ReadOnlyUser, action: Action.View, subject: Subject.App },
  { role: Roles.ReadOnlyUser, action: Action.View, subject: Subject.Scope },
  { role: Roles.ReadOnlyUser, action: Action.View, subject: Subject.Target },
];
